import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Tracker from "@/pages/Tracker";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import DriveDetail from "@/pages/DriveDetail";
import TreeDetail from "@/pages/TreeDetail";

// Admin panel is a separate, lazily-loaded bundle (kept out of the public app).
const AdminApp = lazy(() => import("@/admin/AdminApp"));

function ScrollManager() {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname, location.hash]);
    return null;
}

function PublicSite() {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/tracker" element={<Tracker />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/drive/:id" element={<DriveDetail />} />
                <Route path="/tree/:id" element={<TreeDetail />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route
                        path="/admin/*"
                        element={
                            <Suspense
                                fallback={
                                    <div className="min-h-screen flex items-center justify-center text-seedh-muted">
                                        Loading…
                                    </div>
                                }
                            >
                                <AdminApp />
                            </Suspense>
                        }
                    />
                    <Route path="/*" element={<PublicSite />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
